import { createSlice } from '@reduxjs/toolkit';
import { fetchWarehouseClients, updateWarehouseClient } from './warehouseClientsThunks';
import { selectWarehouse } from '../warehouseContext/warehouseContextSlice';

const initialState = {
  /** Every contract that matches the warehouse in use; the table pages them itself. */
  clients: [],
  loading: false,
  error: null,
  /** The request whose answer may still write. See `fetchWarehouseClients.fulfilled`. */
  requestId: null,
  /** The contract whose preference is being saved, to disable only its switches. */
  busyId: null,
};

const warehouseClientsSlice = createSlice({
  name: 'warehouseClients',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseClients.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.requestId = action.meta.requestId;
      })
      .addCase(fetchWarehouseClients.fulfilled, (state, action) => {
        // Only the latest request may write: the warehouse can be switched
        // while the clients of the previous one are still on their way.
        if (action.meta.requestId !== state.requestId) return;
        state.loading = false;
        state.clients = action.payload;
      })
      .addCase(fetchWarehouseClients.rejected, (state, action) => {
        if (action.meta.requestId !== state.requestId) return;
        state.loading = false;
        state.error = action.payload;
        state.clients = [];
      })

      .addCase(updateWarehouseClient.pending, (state, action) => {
        state.busyId = action.meta.arg.contractId;
      })
      .addCase(updateWarehouseClient.fulfilled, (state, action) => {
        state.busyId = null;
        state.clients = state.clients.map((row) =>
          row.id === action.payload.id ? action.payload : row
        );
      })
      .addCase(updateWarehouseClient.rejected, (state) => {
        state.busyId = null;
      })

      // Another warehouse is another set of contracts.
      .addCase(selectWarehouse, (state) => {
        state.clients = [];
      });
  },
});

export default warehouseClientsSlice.reducer;
